var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      dialog: _vm.show,
      width: "680",
      title: _vm.$t(
        "label_essweb_rosterRecord_form_dialog_generateRosterRecordTitle"
      ),
      maxWidth: "680",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_rosterRecord_form_dialog_rosterNameLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-text-field", {
                          attrs: {
                            dense: "",
                            filled: "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            maxlength: "200",
                            "single-line": "",
                            placeholder: _vm.$t(
                              "label_essweb_rosterRecord_form_dialog_rosterNameLabel"
                            ),
                          },
                          model: {
                            value:
                              _vm.rosterRecordData.roster_form_record_title,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.rosterRecordData,
                                "roster_form_record_title",
                                $$v
                              )
                            },
                            expression:
                              "rosterRecordData.roster_form_record_title",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_rosterRecord_form_dialog_descriptionLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-text-field", {
                          attrs: {
                            dense: "",
                            filled: "",
                            maxlength: "500",
                            "single-line": "",
                            placeholder: _vm.$t(
                              "label_essweb_rosterRecord_form_dialog_descriptionLabel"
                            ),
                          },
                          model: {
                            value:
                              _vm.rosterRecordData
                                .roster_form_record_description,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.rosterRecordData,
                                "roster_form_record_description",
                                $$v
                              )
                            },
                            expression:
                              "rosterRecordData.roster_form_record_description",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_RosterRecord_dialog_dateLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("DateTimePicker", {
                          attrs: {
                            isRequire: "",
                            type: "daterange",
                            value: _vm.curtime,
                            defaultStartTime: _vm.defaultStartDate,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            defaultEndTime: _vm.defaultEndDate,
                            placeholder: _vm.$t(
                              "label_essweb_RosterRecord_list_seTimeLabel"
                            ),
                          },
                          on: {
                            change: function (time, isre) {
                              _vm.curtime = time
                              if (isre) {
                                _vm.defaultStartDate = time
                                  ? time.split(" - ")[0]
                                  : ""
                                _vm.defaultEndDate = time
                                  ? time.split(" - ")[1]
                                  : ""
                              }
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            items: _vm.curStaffs,
                            chips: "",
                            label:
                              "label_essweb_RosterRecord_dialog_staffLabel",
                            filter: _vm.$staffFilter,
                            "deletable-chips": "",
                            multiple: "",
                            avatar: "",
                            "two-line": "",
                            rules: _vm.$GetRules(["_Require_ArrRules"], [null]),
                            "item-text": "staff_code",
                            "item-value": "staff_id",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item.preferred_name
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "selection.avatar",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _c("StaffAvatar", {
                                    attrs: {
                                      size: "36",
                                      left: "",
                                      contentClass: "white--text",
                                      src: data.item.staff_avatar,
                                      staff_name: data.item.preferred_name,
                                    },
                                  }),
                                ]
                              },
                            },
                            {
                              key: "item.avatar",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _c("StaffAvatar", {
                                    attrs: {
                                      size: "36",
                                      src: data.item.staff_avatar,
                                      staff_name: data.item.preferred_name,
                                    },
                                  }),
                                ]
                              },
                            },
                            {
                              key: "item.title",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _c("span", { staticClass: "text-body-2" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item.preferred_name
                                        )
                                      ) + " "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text--secondary text-caption-xs",
                                      },
                                      [_vm._v(_vm._s(data.item.staff_code))]
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "item.subtitle",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item.job_post_name
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.selectStaff,
                            callback: function ($$v) {
                              _vm.selectStaff = $$v
                            },
                            expression: "selectStaff",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            label:
                              "label_essweb_rosterRecord_form_dialog_managersLabel",
                            items: _vm.allStaff,
                            chips: "",
                            filter: _vm.$staffFilter,
                            "deletable-chips": "",
                            avatar: "",
                            "two-line": "",
                            multiple: "",
                            rules: _vm.$GetRules(["_Require_ArrRules"], [null]),
                            "item-text": "staff_code",
                            "item-value": "staff_id",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item.preferred_name
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "selection.avatar",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _c("StaffAvatar", {
                                    attrs: {
                                      left: "",
                                      contentClass: "white--text",
                                      src: data.item.staff_avatar,
                                      staff_name: data.item.preferred_name,
                                    },
                                  }),
                                ]
                              },
                            },
                            {
                              key: "item.avatar",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _c("StaffAvatar", {
                                    attrs: {
                                      size: "36",
                                      src: data.item.staff_avatar,
                                      staff_name: data.item.preferred_name,
                                    },
                                  }),
                                ]
                              },
                            },
                            {
                              key: "item.title",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _c("span", { staticClass: "text-body-2" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item.preferred_name
                                        )
                                      ) + " "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text--secondary text-caption-xs",
                                      },
                                      [_vm._v(_vm._s(data.item.staff_code))]
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "item.subtitle",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item.job_post_name
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.rosterRecordData.managerIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.rosterRecordData, "managerIds", $$v)
                            },
                            expression: "rosterRecordData.managerIds",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            items: _vm.allForm,
                            isRequired: "",
                            label:
                              "label_essweb_rosterRecord_form_dialog_rosterFormLabel",
                            "item-text": "roster_form_name",
                            "item-value": "uuid",
                            "small-chips": "",
                            "deletable-chips": "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          model: {
                            value: _vm.rosterRecordData.roster_form_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.rosterRecordData,
                                "roster_form_uuid",
                                $$v
                              )
                            },
                            expression: "rosterRecordData.roster_form_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_rosterRecord_form_dialog_remarkLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-text-field", {
                          attrs: {
                            dense: "",
                            filled: "",
                            "single-line": "",
                            maxlength: "500",
                            placeholder: _vm.$t(
                              "label_essweb_rosterRecord_form_dialog_remarkLabel"
                            ),
                          },
                          model: {
                            value: _vm.rosterRecordData.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.rosterRecordData, "remarks", $$v)
                            },
                            expression: "rosterRecordData.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: {
                saveBtn: "",
                cancelBtn: "",
                onLoading: _vm.isLoading,
                saveText:
                  "label_essweb_rosterRecord_form_dialog_generateBtnLabel",
              },
              on: { save: _vm.toSave, cancel: _vm.closeDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }